<template>
  <div>
    <div v-if="tourneeAffichage" :key="index"
         class="height-90"
      >
      <div class="columns is-multiline  is-marginless">
        <div class="column is-12 columns is-marginless is-multiline">
          <div class=" has-text-weight-bold ellipsis has-text-link
           column is-4 is-paddingless">
           {{ dateDepart | formatDate }}
          </div>
          <div class="has-text-weight-bold ellipsis has-text-link
          column is-8 is-paddingless">
            {{ tourneeAffichage.tournee }}
          </div>
          <div class="column is-4 is-paddingless">
            {{ tourneeAffichage.libelleJourDepart }}
          </div>
          <div class="column is-8
            is-size-7 has-text-default columns
            is-paddingless is-marginless">
            <span class="column is-5 is-paddingless">
              {{ $t('chargeTravailAff.ressourceAndAffectationInfo.nbFaces',
            { faces: tourneeAffichage.nbFaces }) }}
            </span>
            <span v-if="tourneeAffichage.nbFacesLp != 0" class="column is-6 is-paddingless">
              {{ $t('chargeTravailAff.ressourceAndAffectationInfo.nbFacesLp',
              { facesLp: tourneeAffichage.nbFacesLp }) }}
            </span>
          </div>
        </div>
        <div class="column is-12 columns is-marginless is-multiline pdt-0"
            v-if="tourneeAffichage.ordreTravailId && tourneeAffichage.ordreTravail">
          <router-link-blank :to="{ name: 'c.logistique.ordre_travail-affichage',
            params: { id: tourneeAffichage.ordreTravailId } }"
            :message="tourneeAffichage.ordreTravail.code" class="lien is-inline-block">
          </router-link-blank>
          <a :class="{ 'disabled':
            tourneeAffichage.ordreTravail.etat !== constantes.ETAT_ENREGISTRE }"
            @click.stop="checkPermissions(permsOrdreTravail.supprimer)
                ? openPopUpDelete(tourneeAffichage.ordreTravail.code,
                  tourneeAffichage.ordreTravailId) : showPopUp()"
                class="mgl-5px is-inline-block">
            <b-tooltip
                    :label="$t('chargeTravailAff.ressourceAndAffectationInfo.removeOt')"
                    position="is-right">
              <b-icon
                :class="{'text-access-no-permission':
                  !checkPermissions(permsOrdreTravail.supprimer)}"
                :type="{ 'is-danger':
                  tourneeAffichage.ordreTravail.etat === constantes.ETAT_ENREGISTRE  }"
                icon="delete-forever">
              </b-icon>
            </b-tooltip>
          </a>

        </div>
        <div v-else @click="genererOT(tourneeAffichage)"
          class="lien is-cursor-pointer is-inline-block mgl-10px">
          {{  $t('chargeTravailAff.ressourceAndAffectationInfo.newOt') }}
        </div>
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('listeOrdreTravailAffichage.popUpSuppression.titleCode',
          {code: otToRemove})"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopUp"
        @no="reinitPopup"
        @yes="deleteOt()"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { genererOrdreTravail, deleteAllOt } from '@/api/logistique/ordreTravailAffichage';
import messageSucces from '@/services/general/messageSucces';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import validation from '@/services/logistique/ordreTravail/affichage/validation';
import messageErreur from '@/services/general/messageErreur';
import popUpPrevention from '@/components/general/popUpPrevention';
import { ETAT_ENREGISTRE } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    tourneeAffichage: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
    anneeSemaine: {
      required: true,
      type: Number,
    },
    societeActiveId: {
      required: true,
      type: String,
    },
    dateDepart: {
      required: true,
      type: String,
    },
  },
  components: {
    routerLinkBlank,
    popUpPrevention,
  },
  data() {
    return {
      permsOrdreTravail: ORDRE_TRAVAIL,
      popUpSuppression: false,
      otToRemove: null,
      idToDelete: null,
      messagesPopUp: [],
      isErrorPopUp: false,
      constantes: {
        ETAT_ENREGISTRE,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    async genererOT(tournee) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await genererOrdreTravail({
          anneeSemaine: this.anneeSemaine,
          societeId: this.societeActiveId,
          tfsIds: tournee.ids,
        });
        messageSucces(this.$t('chargeTravailAff.messages.sucess.otCreate'));
        loadingComponent.close();
        this.$emit('reloadRessource');
      } catch (e) {
        loadingComponent.close();
        this.$emit('errorGenerationOT', e);
        throw e;
      }
    },
    openPopUpDelete(otCode, otId) {
      this.otToRemove = otCode;
      this.popUpSuppression = true;
      this.idToDelete = otId;
    },
    async deleteOt() {
      this.messagesPopUp = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAllOt([this.idToDelete]);
        this.popUpSuppression = false;
        messageSucces(this.$t('listeOrdreTravailAffichage.messages.success.otDelete'));
        loadingComponent.close();
        this.reinitPopup();
        this.$emit('reloadRessource');
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopUp = true;
          validation(e.response, this.messagesPopUp);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    reinitPopup() {
      this.popUpSuppression = false;
      this.messagesPopUp = [];
      this.isErrorPopUp = false;
    },
  },
};
</script>
